/** @format */

import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import Dialog from '@material-ui/core/Dialog';

class Loader extends PureComponent {
    render() {
        const { classes, visible } = this.props;

        return (
            <Dialog open={visible}>
                <CircularProgress className={classes.progress + ' ' + classes.adescomLoader} />
            </Dialog>
        );
    }
}

export default withStyles(adescomStyle)(Loader);
